<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'FORMS_TEMPLATES_MODULE.MAPPING.MAPPING_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <button mat-raised-button class="btn btn-primary" (click)="addMapping($event)">
          <span
            inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
            class="svg-icon svg-icon-md"
          ></span>
          <span>{{ 'FORMS_TEMPLATES_MODULE.MAPPING.ADD_MAPPING' | translate }}</span>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.MAPPING.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let link">{{ link.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.MAPPING.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                [placeholder]="'FORMS_TEMPLATES_MODULE.MAPPING.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="modelName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.MAPPING.FORM' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let link">{{ link.form?.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchForm">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchFormAutocomplete
              [label]="'FORMS_TEMPLATES_MODULE.MAPPING.FORM' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getFormAutocomplete"
              [optionFormatter]="formatFormOption"
              [valueFormatter]="formatFormOption"
              [control]="searchFormAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="template_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.MAPPING.TEMPLATE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let link">{{ formatTemplateOption(link.template) }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchTemplate">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchTemplateAutocomplete
              [label]="'FORMS_TEMPLATES_MODULE.MAPPING.TEMPLATE' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getTemplateAutocomplete"
              [optionFormatter]="formatTemplateOption"
              [valueFormatter]="formatTemplateOption"
              [control]="searchTemplateAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="warning">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let link" class="d-flex flex-center">
            <span
              *ngIf="requireReset(link)"
              matTooltip="Reset Mapping"
              [inlineSVG]="'assets/media/svg/icons/Code/Warning-2.svg'"
              class="svg-icon svg-icon-warning cursor-pointer"
              (click)="resetMapping($event, link)"
            ></span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchWarning">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let link">
            <button
              *ngIf="!requireReset(link)"
              matTooltip="{{ 'TABLE.UPDATE' | translate }} Mapping"
              class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
              (click)="updateMapping($event, link)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
